enum OrderTypeEnum {
  READY_DELIVERY = 'ready_delivery',
  CUSTOM_IMPORT = 'custom_import',
}

export default OrderTypeEnum
